import React, {useCallback} from 'react';
import {useTenant} from "../context/tenant";
import {AppBar, Box, Button, IconButton, Toolbar} from '@mui/material';
import {Link as RouterLink} from "react-router-dom";
import {notBlank} from "../utils";
import {LanguageSwitcher, VCLogoBlueOrange} from "@variocube/app-ui";
import {SUPPORTED_LANGUAGES, useLocalization} from "../i18n";

import CityLockerStoreLogo from '../assets/city-locker-store-logo.png';
import CityLockerLogo from '../assets/city-locker_logo_rgb_main.svg';
import HoldMyBagLogo from '../assets/HOLDMYBAG-LOGO-2c-2024-09.svg';
import IntechLogo from '../assets/intech-ics-logo.jpg';
import SchluessfachLogo from '../assets/schluessfach-weiss.svg';
import CityLockersLtd from '../assets/citylokcers-al.png';

export function BrandingBar() {
	const {tenant} = useTenant();
	const {t, ...rest} = useLocalization();

	const renderTenantLogo = useCallback(() => {
		const tenantId = tenant?.id ?? 'varicoube';
		switch (tenantId) {
			case 'citylocker':
				return <CityLockerLogo width="auto" height="48px"/>;
			case 'schluessfach':
				return <SchluessfachLogo width="auto" height="48px"/>;
			case 'citylocker-store':
				return <img style={{height: '70px', width: "auto", padding: '8px'}} alt="citylocker-store" src={CityLockerStoreLogo}/>;
			case 'intech-schweiz':
				return <img style={{height: '48px', width: "auto", padding: '8px'}} alt="intech" src={IntechLogo}/>;
			case 'in-stuttgart':
			case 'd-live-duesseldorf':
			case 'acama-kreuzberg':
			case 'elenas-apartments':
			case 'podersdorf':
				return <HoldMyBagLogo width="auto" height="48px"/>
			case 'city-lockers-ltd':
				return <img style={{height: '48px', width: "auto", padding: '8px'}} alt="Logo City Lockers Ltd" src={CityLockersLtd}/>;
			default:
				return <VCLogoBlueOrange width="auto" height="32px"/>;
		}
	}, [tenant])

	return (
		<AppBar
			position="static"
			color="transparent"
			elevation={0}
		>
			<Toolbar>
				<IconButton
					disableRipple
					component={RouterLink}
					to={`/${tenant?.id}`}
				>
					{renderTenantLogo()}
				</IconButton>
				<Box flexGrow={1} />
				{notBlank(tenant?.imprintUrl) && (
					<Button
						component={RouterLink}
						to={tenant?.imprintUrl as string}
						target="_blank"
					>
						{t('imprint')}
					</Button>
				)}
				{tenant?.id && (
					<LanguageSwitcher
						languages={SUPPORTED_LANGUAGES}
						color="inherit"
						{...rest}
					/>
				)}
			</Toolbar>
		</AppBar>
    );
}
